import { useOpenCloseRemote } from '../hooks/useOpenCloseRemote';
import { useOpenWindowFromDialer } from '../hooks/useOpenWindowFromDialer';
import { useOpenedWindowExists } from '../hooks/useOpenedWindowExists';
import { useRemoteConnectionManager } from '../hooks/useRemoteConnectionManager';

// Handle remote + calling window connection and open widget event
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function UsesCallingWindowIsTrueEvents({
  ownerId
}) {
  useOpenedWindowExists();
  useOpenWindowFromDialer({
    ownerId
  });
  const {
    setIsPopoverMinimized
  } = useOpenCloseRemote();
  useRemoteConnectionManager({
    setIsPopoverMinimized
  });
  return /*#__PURE__*/_jsx(_Fragment, {});
}